import React from "react";

import SearchableSelect from "components/common/searchableSelect/SearchableSelect";
import SearchField from "components/common/customSearchField/CustomSearchField";

import ClearFiltersIcon from "assets/icons/ClearFiltersIcon";
import SortingOrder from "components/common/sortingOrder/SortingOrder";
import Filterbars from "assets/icons/Filterbars";
import "./OwnProducts.scss";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
const OwnProductsActionBar = (props) => {
  const {
    orderByList,
    filters,
    handleChange,
    searchPlaceholder,
    resetFilters,
  } = props;
  const { t } = useTranslation();
  return (
    <div className="maindiv d-flex justify-content-between">
      <Row className="own-products d-flex flex-wrap">
        <Col
          lg={1}
          // sm={5}
          xs={12}
          className="d-flex flex-md-column align-items-center  justify-content-md-center justify-content-around align-item-center flex-row"
        >
          {filters?.orderBy ? (
            <SortingOrder
              handleChange={handleChange}
              value={filters.orderType}
            />
          ) : (
            <div
              style={{
                pointerEvents: "none",
                opacity: 0.4,
              }}
            >
              <SortingOrder
                handleChange={handleChange}
                value={filters.orderType}
              />
            </div>
          )}
          {Object?.values(filters).some(
            (el) => el !== "DESC" && el.length > 0
          ) && <ClearFiltersIcon resetFilters={resetFilters} />}
        </Col>
        <Col lg={3} xs={12} className="">
          <SearchableSelect
            name="orderBy"
            placeholder={t("sort-by")}
            options={orderByList?.map((el) => {
              return { value: el.value, label: el.name };
            })}
            value={filters.orderBy}
            handleChange={handleChange}
          />
        </Col>
        <Col lg={3} xs={12} className="">
          <SearchField
            name="searchString"
            placeholder={searchPlaceholder}
            value={filters.searchString}
            handleChange={handleChange}
          />
        </Col>
      </Row>
    </div>
  );
};

export default OwnProductsActionBar;
